import React from 'react';
import { useField } from 'formik';
import { Image, Message } from 'semantic-ui-react';

import { SignContainer } from './StyledEhsComponents';
import { SignatureModal } from './SignatureModal';

interface SignatureFieldProps {
  name: string;
}

export const SignatureField = ({ name }: SignatureFieldProps) => {
  const [, { value, touched, error }, { setValue }] = useField(name);

  return (
    <SignContainer>
      {touched && error ? <Message error visible content={error} /> : <Image src={value} />}
      <SignatureModal onSignature={(signature) => setValue(signature)} />
    </SignContainer>
  );
};
